export enum MyBookingEndpoints {
  PAY = '/pay',
  INVOICE = '/invoice',
  DOCUMENTS = '/documents'
}
